import { ChangeLanguageActionType, StoreActionType } from './store-action';

export const languageReducer = (
  state: string = window.sessionStorage.getItem('language') || 'en',
  action: ChangeLanguageActionType
): string => {
  // eslint-disable-next-line sonarjs/no-small-switch
  switch (action.type) {
    case StoreActionType.LANGUAGE_CHANGED:
      return action.payload.language;
    default:
      return state;
  }
};
